import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import PageModal from '../../components/PageModal';

const CMSPages = () => {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingPage, setEditingPage] = useState(null);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    loadPages();
  }, []);

  const loadPages = async () => {
    try {
      setLoading(true);
      const response = await api.getPages();
      if (response.success) {
        setPages(response.data || []);
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = () => {
    setEditingPage(null);
    setShowModal(true);
  };

  const handleEdit = (page) => {
    setEditingPage(page);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this page?')) {
      return;
    }

    try {
      const response = await api.deletePage(id);
      if (response.success) {
        loadPages();
      } else {
        setError(response.message);
      }
    } catch (error) {
      setError(error.message);
    }
  };

  const handleSave = async (pageData) => {
    try {
      setError('');
      let response;
      if (editingPage) {
        response = await api.updatePage(editingPage.id, pageData);
      } else {
        response = await api.createPage(pageData);
      }

      if (response.success) {
        setShowModal(false);
        setEditingPage(null);
        loadPages();
      } else {
        setError(response.message);
      }
    } catch (error) {
      setError(error.message);
    }
  };

  if (loading) {
    return <div className="text-center p-4">Loading...</div>;
  }

  return (
    <>
      {error && (
        <div className="alert alert-danger alert-dismissible">
          <button type="button" className="close" onClick={() => setError('')}>&times;</button>
          {error}
        </div>
      )}

      <div className="row mb-3">
        <div className="col-md-12">
          <button className="btn btn-primary btn-sm" onClick={handleCreate}>
            <i className="fas fa-plus"></i> New Page
          </button>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Pages</h3>
            </div>
            <div className="card-body">
              <table className="table table-bordered table-hover">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Title</th>
                    <th>Slug</th>
                    <th>Status</th>
                    <th>Updated</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {pages.length > 0 ? (
                    pages.map(page => (
                      <tr key={page.id}>
                        <td>{page.id}</td>
                        <td>{page.title}</td>
                        <td>{page.slug}</td>
                        <td>
                          <span className={`badge ${
                            page.status === 'published' ? 'bg-success' :
                            page.status === 'draft' ? 'bg-warning' :
                            'bg-secondary'
                          }`}>
                            {page.status}
                          </span>
                        </td>
                        <td>{new Date(page.updated_at).toLocaleDateString()}</td>
                        <td>
                          <button className="btn btn-sm btn-info mr-1" onClick={() => handleEdit(page)}>
                            <i className="fas fa-edit"></i>
                          </button>
                          <button className="btn btn-sm btn-danger" onClick={() => handleDelete(page.id)}>
                            <i className="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center">No pages found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <PageModal
          page={editingPage}
          onSave={handleSave}
          onClose={() => {
            setShowModal(false);
            setEditingPage(null);
          }}
        />
      )}
    </>
  );
};

export default CMSPages;


